import React, { Component } from "react";
import CaseStudyTitle from "../Components/CaseStudyTitle";
import InfoCard from "../Components/InfoCard";
import TheProblem from "../Components/TheProblem";
import CenterIntro from "../Components/CenterIntro";
import LeftIntro from "../Components/LeftIntro";
import RightIntro from "../Components/RightIntro";
import ClientQuoteCarousel from "../Components/TestimonialCarousel";
import Annotation from "../Components/ReputationAnno1";
import Annotation2 from "../Components/ReputationAnno2";
import Annotation3 from "../Components/ReputationAnno3";
import Timeline from "../Components/Timeline";
import CounterSection from "../Components/CounterSection";

import caseStudyCover from "../Assets/img/reputation/rep-thumb.jpg";
import yextPop from "../Assets/img/reputation/rep-yextpop.png";
import repScreen1 from "../Assets/img/reputation/rep-screen.jpg";
import repIntro from "../Assets/img/reputation/rep-intro.png";
import repMobile from "../Assets/img/reputation/rep-mobile-app.png";
import repVideo from "../Assets/img/reputation/rep-prototype.mp4";
import repAutoRespond from "../Assets/img/reputation/auto-respond.png";
import repAutoResponded from "../Assets/img/reputation/auto-responded.png";

import logo from "../Assets/img/reputation/popmenu.svg";
import { motion } from "framer-motion";

const stages = [
  {
    id: 1,
    title: "Review Workflow",
    description:
      "The reputation workflow as a whole would be the first release before we layered any of the AI tools ontop.",
  },
  {
    id: 2,
    title: "AI Responses",
    description:
      "Once the workflow was released, we could add the AI answering feature on top, which included being able to choose their desired tone and autofilling the response textbox with AI-generated content",
  },
  {
    id: 3,
    title: "AI Auto-response",
    description:
      "With the AI infrastructure there, we could build upon that and upsell clients for a fee to upgrade to auto-respond",
  },
  {
    id: 4,
    title: "Integrating with Yext",
    description:
      "Because talks with Yext were dragging on longer than expect to reach an agreement, this was pushed to Stage 4 and introduced new review sources. This was also an upsell.",
  },
  {
    id: 5,
    title: "Reputation Dashboard (in discovery)",
    description:
      "Clients still want more in-depth stats on how their reputation is holding up. This is currently in the discovery phase.",
  },
];

const myQuotes = [
  {
    quote:
      "It doesn’t make me look forward to my week when I know I have to do reviews work.",
    name: "Sarah Chen",
    role: "Head of Product",
    company: "Luminary Labs",
    rating: 5,
    bg: "rgba(0, 0, 0, 0.02)",
  },
  {
    quote:
      "We just want to approve or reject them all asap so they can get published to the site.",
    name: "Marcus Reid",
    role: "CEO",
    company: "Forge Digital",
    rating: 5,
    bg: "rgba(0, 0, 0, 0.02)",
  },
  {
    quote:
      "When I signed up for review responses my hope was that I would have to spend less time reading reviews. Initially, however, that wasn’t the case and I was reading more reviews than ever before, especially since I didn’t read Yelp or Facebook reviews.",
    name: "Priya Nair",
    role: "Marketing Director",
    company: "Axiom Studio",
    rating: 5,
    bg: "rgba(0, 0, 0, 0.02)",
  },
];

const results = [
  {
    quote:
      "When we met in person this morning, we were able to respond to about four or five reviews using the AI in under five minutes. Joshua was extremely impressed how well the AI also responded to the negative reviews. He’s going to pass this on to a GM and now feels very confident that they can handle the task quickly and effectively due to the AI responses.",
    name: "Sarah Chen",
    role: "Head of Product",
    company: "Luminary Labs",
    rating: 5,
    bg: "rgba(0, 0, 0, 0.02)",
  },
  {
    quote:
      "Mike is LOVING the new AI responses. As I was teaching him how to use it, I noticed (and he did too) how easy it was to navigate and use to respond to guests. We also created offers to go along with the responses.",
    name: "Marcus Reid",
    role: "CEO",
    company: "Forge Digital",
    rating: 5,
    bg: "rgba(0, 0, 0, 0.02)",
  },
];

class Reputation extends Component {
  render() {
    return (
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ y: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.75, ease: "easeOut" }}
      >
        <div class="case-study">
          <CaseStudyTitle title="AI Reputation Management" company="Popmenu" />
          <div class="container">
            <div
              class="case-study-hero img-shadow"
              style={{ backgroundImage: "url(" + caseStudyCover + ")" }}
            ></div>

            <div className="row middle-sm">
              <div className="col-md-4 text-right">
                <img src={logo} width="75%" alt="Popmenu Logo" />
              </div>
              <div className="col-md-7">
                <p className="lead">
                  Popmenu is a restaurant technology company that helps
                  restaurateurs build and manage their online presence through
                  websites, dynamic menus, online ordering, and other digital
                  tools.
                </p>
              </div>
            </div>

            <TheProblem
              chip=""
              title="Project Overview"
              content={[
                "Popmenu’s reputation management tool wasn’t meeting customer needs, leading to low engagement and missed revenue. As the sole designer across the mobile app and desktop, I redesigned the experience to simplify review management while integrating AI to help respond to reviews — increasing response rates 5x and driving meaningful revenue growth.",
              ]}
              role="Senior Product Designer"
              timeline="6 months"
              team="Product Manager and team of 5 engineers"
              img={repIntro}
            />
            <section className="mt-10">
              <CenterIntro
                chip="Discovery & research"
                title="Discovering our user's true pain point"
                content={[
                  "Leadership initially came to my PM and me with a question: **how can we better demonstrate the ROI of our reviews feature?** The proposed solution was a dashboard highlighting metrics like total reviews, response rate, sentiment, and new reviews awaiting responses. They wanted to reduce churn by showing clients what Popmenu already does for them.",
                  "But based on past client feedback, **I knew the bigger issue wasn’t visibility: it was usability.** Restaurant owners were already struggling with the workflow itself. Before investing in a metrics dashboard, I pushed leadership and my PM to validate whether a dashboard would actually solve their problems. I advocated for user research to understand where the real friction lived and whether surfacing stats would drive impact or just add polish to an experience users already avoided.",
                ]}
              />

              {/* <div className="container-medium">
                <div className="row row-mtmb">
                  <div className="col-md-6" style={{ display: "flex" }}>
                    <UserCard
                      title="Restaurant Owners/Staff"
                      content="Popmenu’s users are restaurant owners of single location or multi-location restaurants. They are extremely busy, bouncing between one task to another and not able to find time to spend hours on the computer for admin tasks."
                    />
                  </div>
                  <div className="col-md-6" style={{ display: "flex" }}>
                    <UserCard
                      title="Marketing"
                      content="Some larger restaurants hire marketing professionals to manage their brand through social media, emails, and print. They also were the ones that responded to reviews."
                    />
                  </div>
                </div>
              </div> */}

              <div className="row row-mtmb">
                <div className="col-md-7 m-auto">
                  <h3>How was the current workflow treating them?</h3>
                  <p className="">
                    I conducted several customer interviews to better understand
                    how users approached review management. While leadership
                    wanted to show more data and reporting, customers
                    consistently pointed to the core issue that I had assumed
                    was the issue:{" "}
                    <strong>
                      the workflow itself was the real pain point.
                    </strong>
                  </p>
                  <p>
                    Review management felt slow, tedious, and mentally draining.
                    This frustration wasn’t new—there had already been a
                    previous redesign attempt aimed at improving the workflow,
                    but it failed to meaningfully solve the problem.
                  </p>
                </div>
              </div>

              <Annotation />

              <div className="row row-mtmb">
                <div className="col-md-7 m-auto">
                  <p>
                    Many clients expressed disappointment in the current review
                    feature and found it impossible to work with. One review
                    would, on average, take a user 5 minutes to respond to,
                    especially if it was a negative review that they had to
                    craft a thoughtful response to. There were also other
                    problems that we uncovered:
                  </p>
                  <ul>
                    <li>
                      Approving or rejected by email notification would redirect
                      them to Popmenu, but then they wouldn't be able to find
                      that review in the list
                    </li>
                    <li>
                      There was no clear way to see whether or not the review
                      was responded to and when
                    </li>
                    <li>
                      There are no filters to sort reviews by location, status,
                      etc.
                    </li>
                    <li>
                      In the age of AI, users wanted response templates to work
                      off of to save time
                    </li>
                    <li>
                      Users wanted to integrate with more sources, like
                      Facebook, Yelp, etc.
                    </li>
                  </ul>
                  <p>
                    Below are some of the quotes that stood out to me during
                    researching:
                  </p>
                  <ClientQuoteCarousel quotes={myQuotes} />
                </div>
              </div>

              <div className="row row-mtmb">
                <div className="col-md-7 m-auto">
                  <h3>Pivoting to fixing the workflow</h3>
                  <p>
                    I pulled the research together and walked leadership through
                    what we were hearing from users. The takeaway was clear: the
                    issue wasn’t a lack of metrics —{" "}
                    <b>the workflow itself was frustrating to use.</b>
                  </p>
                  <p>
                    Together, we decided to pivot. Instead of building a
                    stats-heavy dashboard, we focused on fixing the core
                    experience first. Improving how restaurant owners actually
                    managed reviews was far more impactful than layering
                    analytics onto something they already avoided.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <InfoCard
                    style="#E8F3DA"
                    title="📊 Add a basic overview "
                    content={[
                      "Show users basic stats that they need to track how well they’re doing with reviews.",
                    ]}
                  />
                </div>
                <div className="col-md-4">
                  <InfoCard
                    style="#DFDDF9"
                    title="🗂️ Improve organization"
                    content={[
                      "This was a given when looking at the current experience. We needed to make it more organized and user friendly so that completing tasks didn’t take up time.",
                    ]}
                  />
                </div>
                <div className="col-md-4">
                  <InfoCard
                    style="#E8F6FF"
                    title="🤖 Leverage AI to help respond"
                    content={[
                      "With ChatGPT readily available, we could help craft responses to reviews based on the review content to help save time for our users.",
                    ]}
                  />
                </div>
              </div>
              {/* <div className="row row-mtmb">
                <div className="col-md-6">
                  <h3>Pivoting to fixing the workflow</h3>
                  <p className="">
                    My PM and I conducted several customer interviews to better
                    understand how users approached review management. While
                    leadership wanted to show more data and reporting, customers
                    consistently pointed to something else:{" "}
                    <strong>
                      the workflow itself was the real pain point.
                    </strong>
                  </p>

                  <p>
                    Review management felt slow, tedious, and mentally draining.
                    This frustration wasn’t new—there had already been a
                    previous redesign attempt aimed at improving the workflow,
                    but it failed to meaningfully solve the problem.
                  </p>
                  <p>
                    Based on these insights, I brought the findings back to
                    leadership. We collectively decided to pivot away from
                    building a metrics-heavy dashboard and instead focus on
                    fixing the core experience. Improving review management was
                    far more valuable than surfacing stats on top of an
                    experience users already disliked.
                  </p>
                </div>
                <div className="col-md-6">
                  <ClientQuoteCarousel quotes={myQuotes} />
                </div>
              </div> */}
            </section>

            <section className="section green">
              <LeftIntro
                chip="Strategy & design"
                title="Designing for scalability and growth"
                content={[
                  "Redesigning the reputation workflow wasn’t just about improving UX, it was about **setting Popmenu up for growth.** At the time, clients could only manage reviews from Popmenu and Google, which limited both value and revenue. As the business explored integrating with Yext, I designed the system to scale to many additional review sources from day one, rather than retrofitting later. ",
                  "That foundation allowed us to expand coverage across the broader review ecosystem and create a clear upsell path for clients who wanted more sources, **increasing product value and unlocking new revenue opportunities.**",
                ]}
                img={yextPop}
              />
              <div className="row row-mtmb">
                <div className="col-md-7 m-auto">
                  <h3>Improving scannability and information hierarchy</h3>
                  <p>
                    Before jumping into solutions, I conducted a competitive
                    analysis of review management platforms, including Yext, to
                    understand industry standards and identify opportunities to
                    differentiate. A consistent theme was clear status
                    visibility and scannability at scale.
                  </p>
                  <p>
                    To address this, I explored multiple table-based layouts
                    that made review status, source, and response progress easy
                    to scan and act on.{" "}
                    <b>Design 3 is what I ended up choosing</b> because it made
                    the most sense for our users’ needs. The basic needs
                    included:
                  </p>
                  <ul>
                    <li>Review Source</li>
                    <li>Name, star rating, review preview</li>
                    <li>Timestamp when it was posted</li>
                    <li>Sentiment (using AI to assign sentiment)</li>
                    <li>Restaurant location</li>
                    <li>Actions</li>
                  </ul>
                </div>
                <div className="row row-mtmb">
                  <Annotation2 />
                </div>
              </div>

              <div className="row row-mtmb">
                <div className="col-md-7 m-auto">
                  <p>
                    While improving the workflow was the priority, I also
                    recognized that users still wanted performance visibility —
                    so I introduced lightweight metric cards above the table to
                    surface key insights without overwhelming the core task
                    experience. This experience would suffice <b>until we had time to revisit a more in-depth dashboard.</b>
                  </p>
                  <img
                    src={repScreen1}
                    width="100%"
                    alt="Screen of reputation management table"
                  />
                </div>
              </div>
              <div className="row row-mtmb">
                <div className="col-md-7 m-auto">
                  <h3>Crafting a new response modal</h3>
                  <p>
                    Replies were originally handled in a simple modal, but I
                    shifted to a slide-out panel to better support scale as we
                    layered in more actions and AI-generated responses. Popmenu
                    reviews included expanded capabilities, like attaching
                    offers and publishing to a website, while third-party
                    sources (e.g., Google) had more limited actions. I also
                    introduced a color-coded sentiment bar to make each review’s
                    tone instantly scannable.
                  </p>
                </div>
              </div>
              <Annotation3 />
              <div className="row row-mtmb">
                <div className="col-md-7 m-auto">
                  <h3>Designing for the mobile app</h3>
                  <p>
                    Restaurant owners and managers are always on the move, so a
                    desktop-only experience wasn't going to cut it. I pushed to
                    bring review management into the Popmenu for Owners mobile
                    app — but kept it intentionally lightweight. My PM wanted to
                    include the full review history, and while I understood the
                    appeal, I knew that would slow things down significantly on
                    mobile. We landed on <b>scoping it to new reviews only</b>,
                    which kept the experience fast and actually useful for
                    operators in the middle of a busy shift.
                  </p>
                </div>
              </div>
              <div className="row row-mtmb">
                <div className="col-md-9 m-auto">
                  <img
                    src={repMobile}
                    width="100%"
                    alt="Three screens of showing the mobile app designs"
                  />
                </div>
              </div>
            </section>

            <section>
              <CenterIntro
                chip="Feedback & iteration"
                title="Testing the designs with clients"
                content={[
                  "With all of these pieces, I created a prototype and wanted to validate my assumptions with clients. Was this view easier to use? Are they better able to see the status and source of each review? I also wanted to pick their brains about what their expectations were with AI helping them respond to reviews since, at the time, AI was newer amongst the mainstream population. I met with the same clients I talked to previously to conduct this usability testing.",
                ]}
              />
              <div className="row row-mtmb">
                <div className="col-md-9 m-auto">
                  <video
                    autoPlay
                    muted
                    playsInline
                    loop
                    width="100%"
                    src={repVideo}
                    type="video/mp4"
                  >
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
              <div className="row row-mtmb">
                <div className="col-md-7 m-auto">
                  <p>Some of the common patterns that I discovered were:</p>
                  <ul>
                    <li>
                      Clients wanted a deeper data analysis of their reputation
                      and sentiments that showed graphics over time (something
                      we were already looking at)
                    </li>
                    <li>
                      They wanted to share the review, either on social media or
                      to the people they worked with (for example, an owner will
                      want to share it with a general manager)
                    </li>
                    <li>
                      The review slideout width was too small–they had to scroll
                      more to read longer reviews
                    </li>
                    <li>
                      Some clients wanted AI to do more work for them and
                      automatically respond to reviews. Sometimes they didn’t
                      care about a certain review source, like Facebook, and
                      wanted AI to post responses for them
                    </li>
                  </ul>
                </div>
              </div>
            </section>

            <section className="section teal">
              <CenterIntro
                chip="Iteration"
                title="Adding AI Auto-Respond"
                content={[
                  "Clients wanted AI to do the heavy lifting — but with guardrails. They were comfortable letting AI auto-respond to positive reviews (4-5 star 3rd-party reviews), but hesitated when it came to negative ones. Negative reviews require more nuance, and clients weren't ready to give up control of that narrative. However, they didn’t mind having AI generate a suggested response and tweaking/approving it from there.",
                  "In the system, we needed admin settings to add different “rules” for the AI to abide by, with the ability to customize instructions and control when to auto-post the response.",
                ]}
              />
              <div className="row row-mtmb">
                <div className="col-md-9 m-auto">
                  <img
                    src={repAutoRespond}
                    width="100%"
                    alt="Screen of reputation management table"
                  />
                  <p className="text-caption">
                    We started off with only adding rules for positive or 4-5
                    star reviews, since client sentiment around auto-responding
                    to negative reviews was tepid.
                  </p>
                </div>
              </div>
              <div className="row row-mtmb">
                <div className="col-md-7 m-auto">
                  <p>
                    And on the review UI, we needed a way to show them that a
                    response was auto-responded to. I added a chip to visually
                    indicate this. The user could go back and edit the response
                    if needed and the author would update to the user’s name in
                    that case. In feedback sessions with clients, they wanted
                    the ability for the auto-responder to also attach an offer
                    to the response. However, that was something we were going
                    to wait on.
                  </p>
                </div>
              </div>
              <div className="row row-mtmb">
                <div className="col-md-7 m-auto">
                  <img
                    src={repAutoResponded}
                    width="100%"
                    alt="Two screens of auto-response UI"
                  />
                  <p className="text-caption">
                    The first screen shows a review that is already in the
                    auto-response queue. The second screen shows what it looks
                    like when it was auto-responded.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <CenterIntro
                title="Releasing it in stages"
                content={[
                  "Because this was quite a hefty project with leadership wanting this out the door quickly and engineers giving feedback that a lot of it couldn’t be done in that amount of time, **I suggested to my team that we release it in stages.** ",
                ]}
              />
              <div className="row row-mtmb">
                <div className="col-md-7 m-auto">
                  <Timeline items={stages} />
                </div>
              </div>
            </section>
            <section className="section purple">
              <CenterIntro
                title="Results"
                content={[
                  "Following the full product release, client response rates **surged 5x** — enabling clients to respond to 5 reviews in 5 minutes compared to just 1 review in the same timeframe. This efficiency gain drove **strong demand for upsells**, generating incremental revenue through both the AI Auto-Respond and Yext integration offerings.",
                ]}
              />
              <div className="row row-mtmb">
                <div className="col-md-9 m-auto">
                  <ClientQuoteCarousel quotes={results} />
                </div>
              </div>
            </section>
          </div>
        </div>
      </motion.div>
    );
  }
}

export default Reputation;
